// extracted by mini-css-extract-plugin
export default {"formHolder":"Agreement_formHolder__UfhlK"};